// extracted by mini-css-extract-plugin
export default {"section":"Flow_section__GssUW","swiperBox":"Flow_swiperBox__jFC2d","boxLabel":"Flow_boxLabel__jqlib","boxTitle":"Flow_boxTitle__81t6O","boxDescription":"Flow_boxDescription__S3hq5"};